import { Login } from './components/login/Login';
import { ForgotPasswordLanding } from './components/forgot-password/Landing';
import { CreateAccountLanding } from './components/create-account/Landing';
import { RouteObject } from 'react-router-dom';

export const authRoutes: RouteObject[] = [
  {
    path: '/login/:tenant?/:utilityName?',
    element: <Login />,
  },
  {
    path: '/forgot-password/:tenant?/:utilityName?',
    element: <ForgotPasswordLanding />,
  },
  {
    path: '/create-account/:tenant?/:utilityName?',
    element: <CreateAccountLanding />,
  },
];
